var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 22,
    viewBox: "0 0 28 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.125 5.98438L5.5 13.1094V20.75C5.5 21.1719 5.82812 21.5 6.25 21.5H11.5C11.875 21.5 12.2031 21.1719 12.2031 20.75V16.25C12.2031 15.875 12.5781 15.5 12.9531 15.5H15.9531C16.375 15.5 16.7031 15.875 16.7031 16.25V20.75C16.7031 21.1719 17.0781 21.5 17.4531 21.5H22.75C23.125 21.5 23.5 21.1719 23.5 20.75V13.0625L14.8281 5.98438C14.7344 5.89062 14.5938 5.84375 14.5 5.84375C14.3594 5.84375 14.2188 5.89062 14.125 5.98438ZM27.7656 10.8125L15.9062 1.01562C15.5781 0.734375 14.9219 0.546875 14.4531 0.546875C14.0312 0.546875 13.375 0.734375 13.0469 1.01562L1.1875 10.8125C1.04688 10.9062 0.953125 11.0938 0.953125 11.2344C0.953125 11.375 1.04688 11.5156 1.09375 11.6094L2.3125 13.0625C2.40625 13.1562 2.59375 13.25 2.73438 13.25C2.82812 13.25 3.01562 13.2031 3.10938 13.1094L14.125 4.0625C14.2188 3.96875 14.3594 3.92188 14.5 3.92188C14.5938 3.92188 14.7344 3.96875 14.8281 4.0625L25.8438 13.1094C25.9375 13.2031 26.125 13.25 26.2188 13.25C26.3594 13.25 26.5469 13.1562 26.6406 13.0625L27.8594 11.6094C27.9062 11.5156 28 11.375 28 11.2344C28 11.0938 27.9062 10.9062 27.7656 10.8125Z",
    fill: "#2D5049"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeSelected);
export default __webpack_public_path__ + "static/media/home-selected.584a553c395fc71e04a6dd6055ab780d.svg";
export { ForwardRef as ReactComponent };